// @flow
import * as React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CRModal, ModalCloseButton } from '@coverright/ui/shared';
import { useEffect, useState } from 'react';
import { useOutdatedFollowUps } from '../hooks/use-outdated-follow-ups';
import moment from 'moment';
import { useOutdatedSql } from '../hooks/use-outdated-sql';

type Props = {
  agentId?: string
};
export const OutdatedLeadsModal = ({agentId}: Props) => {
  const [open, setOpen] = useState(false);
  const outdatedFollowUps = useOutdatedFollowUps(agentId);
  const outdatedSql = useOutdatedSql(agentId);

  useEffect(() => {
    const showedDate = localStorage.getItem('outdatedLeadsModalShowedDate');
    if (((outdatedFollowUps?.length || 0) + (outdatedSql?.length || 0)) && showedDate !== moment().format('L')) {
      setOpen(true);
      localStorage.setItem('outdatedLeadsModalShowedDate', moment().format('L'))
    }
  }, [outdatedFollowUps?.length, outdatedSql?.length]);

  return (
    <CRModal open={open} width={700} paperPadding={3} onClose={() => setOpen(false)} >
      <Stack gap={1}>
        <Stack direction="row" alignItems={'center'} justifyContent={'space-between'}>
          <Typography  variant={'h2'}>
            Hey! Welcome back.
          </Typography>
          <ModalCloseButton onClick={() => setOpen(false)} />
        </Stack>

        <Divider />

        <Typography variant={'subtitle1'}>
          You have {!!outdatedSql?.length && <><Box component={'b'} sx={{color: 'error.500'}}>{outdatedSql?.length}</Box> outdated SQLs</>} {!!outdatedSql?.length && !!0 && ' and '} {!!outdatedFollowUps?.length && <><Box component={'b'} sx={{color: 'error.500'}}>{outdatedFollowUps?.length}</Box> outdated Follow Up</>} <b>contact dates</b>. <b>Please update clients</b> to the correct Status and Contact Date first before your day begins
        </Typography>
      </Stack>
    </CRModal>
  );
};
